import React from "react";

class CompanyTagEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newCompanyTag: ""
    };
  }

  companyTagRemoveEdit = async change => {
    let { companyTags } = this.props;
    let updatedCompanyTags = companyTags.filter(item => item !== change);
    await this.props.onChange({ companyTags: updatedCompanyTags });
  }

  companyTagAssignEdit = async () => {
    let { companyTags } = this.props;
    let { newCompanyTag } = this.state;
    if (newCompanyTag) {
      if (companyTags && companyTags.includes(newCompanyTag))
        alert("Company Tag is already exist");
      else {
        let updatedCompanyTags = [...companyTags, newCompanyTag];
        this.setState({ newCompanyTag: "" });
        await this.props.onChange({ companyTags: updatedCompanyTags });
      }
    }
  }

  render() {
    const { companyTags } = this.props;
    return (
      <div className="">
        {
          this.renderMain()
        }
      </div>
    );
  }

  renderMain = () => {
    const { companyTags } = this.props;

    return (
      <form className="d-flex flex-column mtz-gap-16 mtz-rounded-16"
        onSubmit={(event) => {
          event.preventDefault();
          this.companyTagAssignEdit();
        }}>
        <div className="d-flex mtz-gap-8 bg-white mtz-p-16 mtz-rounded-16 flex-wrap">
          {
            companyTags && companyTags.length > 0 && companyTags.map(companyTag => {
              return (
                <span className="py-1 px-3 border border-primary text-primary mtz-rounded-16"
                  key={companyTag}
                >
                  #{companyTag} <button onClick={() => this.companyTagRemoveEdit(companyTag)} className="text-danger fa fa-trash btn btn-sm close"></button>
                </span>
              );
            })
          }
        </div>

        <div className="form-group">
          <label className="w-100 ">
            Please enter tag name:
            <input
              placeholder={`Please enter tag name`}
              className="form-control"
              onChange={(event) => {
                let val = event.target.value;
                val = val.trim().toLowerCase();
                val = val.replace(/[^a-z0-9_]+/g, '');
                this.setState({ newCompanyTag: val });
              }}
              value={this.state.newCompanyTag}
            />
          </label>
          <div>
            <small><i className="text-danger">* Tags must only contain letters, numbers, and underscore.</i></small>
          </div>
        </div>

        <div className="text-right">
          <button className="btn btn-primary">
            Add
          </button>
        </div>
      </form >
    );
  }

}

export default CompanyTagEdit;
